import React, { useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { TooltipProvider, Tooltip, TooltipTrigger, TooltipContent, } from '@cargomatic/ui';
import { sluggify } from 'utils/localization/utils';
import { getFormatDateTimeWithRegionalSettings } from 'common/helpers/dateUtils';
import { getFileIconClass } from '../../../helpers/helper_functions';
import { DocumentDeleteButton } from './DocumentDeleteButton';
import Badge from '../../v2/Badge';
import { getSignedUrl } from '../../../utils/DocumentsAPIUtils';
import { showToast } from '../../../stores/ToastStore';
export const DOCUMENT_STATUSES = {
    PENDING: 'PENDING',
    UPLOADED: 'UPLOADED',
    UPLOAD_FAILED: 'UPLOAD_FAILED',
};
export const DOCUMENT_STATUSES_TITLE_MAP = {
    [DOCUMENT_STATUSES.PENDING]: 'Pending',
    [DOCUMENT_STATUSES.UPLOADED]: 'Uploaded',
    [DOCUMENT_STATUSES.UPLOAD_FAILED]: 'Upload failed',
};
export const Document = ({ isOrder, document, deleteDisabled, onDeleteConfirm, onDeleteDecline, isSent, }) => {
    const [url, setUrl] = useState(null);
    const { t } = useTranslation();
    const documentName = t(sluggify(document.name));
    const extension = (((document === null || document === void 0 ? void 0 : document.key) || '').split('.').pop() || '').toUpperCase();
    useEffect(() => {
        setUrl(null);
    }, [document.key]);
    const openDocument = async () => {
        var _a;
        let signedUrl = url;
        if (!url) {
            if (!(document === null || document === void 0 ? void 0 : document.key)) {
                showToast(t('GET_SIGNED_URL_ERROR'), t('DOCUMENT_URI_MISSING', { docName: (document === null || document === void 0 ? void 0 : document.name) || 'DOCUMENT' }), 'error');
                return;
            }
            const { data, errors } = await getSignedUrl(document.key);
            if (errors) {
                showToast(t('GET_SIGNED_URL_ERROR'), t('GET_SIGNED_URL_FAILED_WITH_ERROR', { error: errors[0].message }), 'error');
                return;
            }
            signedUrl = (_a = data === null || data === void 0 ? void 0 : data.getSignedUrl) === null || _a === void 0 ? void 0 : _a.signedUrl;
            if (!signedUrl) {
                showToast(t('GET_SIGNED_URL_ERROR'), t('GET_SIGNED_URL_FAILED_WITH_ERROR', {
                    error: 'Missing signed URL',
                }), 'error');
                return;
            }
            setUrl(signedUrl);
        }
        if (signedUrl) {
            window.open(signedUrl, '_blank');
        }
    };
    return (React.createElement(TooltipProvider, null,
        React.createElement("tr", { "data-testid": "tr-5721e957" },
            React.createElement("td", { "data-testid": "td-f85c0370" },
                React.createElement("div", { "data-testid": "div-1843e570", className: "flex items-center space-x-2" },
                    React.createElement("i", { "data-testid": "i-ff471a3c", className: getFileIconClass(extension) }),
                    React.createElement(Tooltip, null,
                        React.createElement(TooltipTrigger, { asChild: true },
                            React.createElement("button", { "data-testid": "a-f71a9fae", type: "button", className: "block max-w-[100px] truncate text-left text-blue-600 hover:underline focus:outline-none focus:ring-2 focus:ring-blue-500 focus:ring-offset-2", onClick: openDocument }, documentName)),
                        React.createElement(TooltipContent, { side: "top", className: "max-w-md break-all" }, documentName)))),
            React.createElement("td", { "data-testid": "td-150be71d" },
                React.createElement("span", { "data-testid": "span-37c2fee7" }, document.createdAt &&
                    getFormatDateTimeWithRegionalSettings(document.createdAt))),
            React.createElement("td", { "data-testid": "td-e00aae74" },
                React.createElement("div", { "data-testid": "div-e44c2286", className: "flex items-center space-x-1" },
                    isSent && (React.createElement(Badge, { dataTestId: "Badge-3e5eecae", color: "green" }, t('EMAIL_SENT'))),
                    document.signatory && !isSent && (React.createElement(Badge, { dataTestId: "Badge-47376021", color: "green" }, document.signatory)))),
            React.createElement("td", { "data-testid": "td-7d40b57e" }, document.status && (React.createElement("small", { "data-testid": "small-cd1270ab" },
                React.createElement("i", { "data-testid": "i-a2e4584d" }, t(sluggify(DOCUMENT_STATUSES_TITLE_MAP[document.status] || 'Unknown')))))),
            React.createElement("td", { "data-testid": "td-99e8b169", style: { whiteSpace: 'nowrap' } },
                React.createElement("span", { "data-testid": "span-b44dc529" },
                    document.firstName,
                    " ",
                    document.lastName)),
            React.createElement("td", { "data-testid": "td-661bca7f" },
                React.createElement("div", { "data-testid": "div-791e6132", className: "flex items-center space-x-1" }, !deleteDisabled && (React.createElement(DocumentDeleteButton, { isOrder: isOrder, document: document, onConfirm: onDeleteConfirm, onDecline: onDeleteDecline })))))));
};
